import type { OnboardingStepDeps } from '@/composables/useOnboarding';
import i18n from '@/i18n';
import { createActionStep, createInfoStep } from '@/onboarding/stepStyles';
import type { StepOptions } from 'shepherd.js';
import 'shepherd.js/dist/css/shepherd.css';
import { nextTick } from 'vue';
import type { Composer } from 'vue-i18n';

const t = (key: string) => (i18n.global as unknown as Composer).t(key);

export function getScanSteps({ tour, router, waitForElement }: OnboardingStepDeps): StepOptions[] {
  return [
    // 16.6 — Transition vers scan
    createActionStep(
      {
        id: 'transition-to-scan',
        title: t('onboarding.chapters.scan.steps.transition-to-scan.title'),
        text: t('onboarding.chapters.scan.steps.transition-to-scan.text'),
        attachTo: { element: '.onboarding-home', on: 'top' },
        canClickTarget: true,
        advanceOn: { selector: '.onboarding-home', event: 'click' },
        beforeShowPromise: async () => {
          await waitForElement('.onboarding-home', 10000);
          await nextTick();
        },
      },
      {
        placement: 'right',
      },
    ),

    // 16.7 — Scan bouton
    createActionStep({
      id: 'scan-intro',
      title: t('onboarding.chapters.scan.steps.scan-intro.title'),
      text: t('onboarding.chapters.scan.steps.scan-intro.text'),
      attachTo: { element: '#scan-recipes-button', on: 'bottom' },
      canClickTarget: true,
      advanceOn: { selector: '#scan-recipes-button', event: 'click' },
      beforeShowPromise: async () => {
        if (router.currentRoute.value.path !== '/') {
          console.log("[Onboarding] Retour à l'accueil...");
          await router.push({ path: '/' });
          await nextTick();
        }

        await waitForElement('#scan-recipes-button', 10000);
        await nextTick();
      },
    }),
    // 17 — Scan
    createActionStep({
      id: 'scan',
      title: t('onboarding.chapters.scan.steps.scan.title'),
      text: t('onboarding.chapters.scan.steps.scan.text'),
      attachTo: { element: '.onboarding-scan-details [data-pc-name="button"]', on: 'top' },
      canClickTarget: true,
      advanceOn: { selector: '.onboarding-scan-details [data-pc-name="button"]', event: 'click' },
      beforeShowPromise: async () => {
        await waitForElement('.onboarding-scan-details [data-pc-name="button"]', 10000);
        await nextTick();
      },
      buttons: [{ text: t('onboarding.common.previous'), action: () => tour.value?.back(), secondary: true }],
    }),
    // 17.2 — Choix de la méthode de scan
    createInfoStep({
      id: 'scan-options',
      title: t('onboarding.chapters.scan.steps.scan-options.title'),
      text: t('onboarding.chapters.scan.steps.scan-options.text'),
      attachTo: { element: '.onboarding-scan-details', on: 'top' },
      canClickTarget: false,
      beforeShowPromise: async () => {
        await nextTick();
      },
      buttons: [{ text: t('onboarding.common.next'), action: () => tour.value?.next() }],
    }),
  ];
}
